<!--
 * @Author: your name
 * @Date: 2020-02-08 22:23:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 -->
<template>
  <div id="app">
    <keep-alive>
      <router-view :key="$route.fullPath" />
    </keep-alive>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import { I18N_URL } from './constants'
import { loadPrintJS } from '@/utils/LodopFuncs.js'
import debounce from 'lodash/debounce'
const IS_DEVELOPMENT = process.env.NODE_ENV === 'development'

export default {
  name: 'App',
  data() {
    return {
      i18nKey: new Date().getTime()
    }
  },
  computed: {
    ...mapGetters(['lang'])
  },
  watch: {
    // 监听国际化语种字段，有更新且不为空时重新获取国际化数据，同时更新缓存中的国际化数据
    lang: {
      handler(val, nval) {
        if (val && val !== nval) {
          this.getI18nData(val)
          // 设置html page lang
          document.documentElement.lang = val && val.toLowerCase()
          if (val && val.toLowerCase() === 'ar') {
            document.documentElement.dir = 'rtl'
          } else {
            document.documentElement.dir = 'ltr'
          }
        }
      },
      // 初始化的时候执行
      immediate: true
    }
  },
  created() {
    this.initI18nData()
    loadPrintJS()
  },
  mounted() {
    // 定时器对比当前系统和发版后的系统的版本哈希值
    this.versionTimeState = setInterval(this.compareVersionHash, 60 * 1000)
  },
  methods: {
    ...mapActions(['SET_LANG', 'SET_LANG_JSON', 'SET_DEFAULT_LANG', 'SET_LANG_LIST']),
    // 获取文本节点的hash
    getDocumentHash(element) {
      const scriptList = [...element.querySelectorAll('script')]
      const hashSrc = scriptList.find(item => item.src.indexOf('js/app.') > -1).src.split('/')
      const hash = hashSrc ? hashSrc[hashSrc.length - 1].split('.')[1] : ''
      return hash
    },
    async compareVersionHash() {
      if (IS_DEVELOPMENT) return
      // 在 js 中请求首页地址不会更新页面
      const response = await axios.get(`${window.location.protocol}//${window.location.host}/?t=${Date.now()}`)
      // 返回的是字符串，需要转换为 html
      const el = document.createElement('html')
      el.innerHTML = response.data
      const newHash = this.getDocumentHash(el)
      // console.log(newHash)
      const curHash = this.getDocumentHash(document)
      // console.log(curHash)
      // iMessage 是个全局变量（默认值 false），用来帮助判断什么时候会弹出提示，不然定时器5s就弹一次了
      if (newHash !== curHash && !this.iMessage) {
        // 版本更新，弹出提示
        this.iMessage = true
        this.$message({
          type: 'info',
          message: '系统版本已升级，将在3秒后自动刷新',
          duration: 3000,
          onClose: () => {
            // location.reload()
            this.iMessage = false
          }
        })
      }
    },
    // 初始化系统国际化数据
    async initI18nData() {
      // 语言列表
      this.getLangList()
      // 获取本地语言信息
      let lan = localStorage.getItem('lang')
      // 本地语种存在
      if (lan) {
        // 更新store中默认语言
        this.SET_DEFAULT_LANG(lan)
      } else {
        // 获取数据库的默认语种信息
        lan = await this.getDefaultLang()
      }
      // 获取国际化数据
      lan && this.getI18nData(lan)
    },

    //  获取默认语言
    async getDefaultLang() {
      try {
        const { data: { code, msg, data = '' } = {}} = await axios.get(`${I18N_URL}/i18n/dictionary/getDefaultLang`)
        if (code === 1 && data) {
          // 更新store中的系统当前语言
          this.SET_LANG(data)
          // 更新store中默认语言
          return this.SET_DEFAULT_LANG(data)
        } else {
          console.error(msg)
        }
      } catch (error) {
        console.error('getI18nData::error', error)
      }
    },
    // 获取语言列表
    async getLangList(lang) {
      try {
        const { data: { code, msg, data = [] } = {}} = await axios.get(`${I18N_URL}/i18n/dictionary/getLang`)
        if (code === 1) {
          const list = data.map(item => ({ label: item.label, value: item.val, local: item.local }))
          // 更新store中语言列表
          this.SET_LANG_LIST(list)
        } else {
          console.error(msg)
        }
      } catch (error) {
        console.error('getI18nData::error', error)
      }
    },
    // 获取国际化数据
    getI18nData: debounce(async function(lang) {
      try {
        const { data: { code, msg, data } = {}} = await axios.get(`${I18N_URL}/i18n/sysInternational/getSysInternationalList`, {
          params: {},
          headers: {
            langType: lang
          }
        })
        if (code === 1) {
          // 更新store中国国际化数据
          this.SET_LANG_JSON(data).then(() => {
            // 更新路由key，保证页面内的界面重载更新语言数据
            this.i18nKey = new Date().getTime()
            console.log(this.i18nKey)
          })
        } else {
          console.error('getI18nData::fail', msg)
        }
      } catch (error) {
        console.error('getI18nData::error', error)
      }
    }, 500)
  },
  destroyed() {
    clearInterval(this.versionTimeState)
  }
}

</script>

<style lang="scss" rel="text/css">
@import "assets/iconfont/iconfont.css";
// .bgImg {
//   background-repeat: no-repeat;
//   background-position: top;
//   background-size: cover;
//   background-image: url('assets/images/bg/bg-vip.jpg');
//   transition: background-image 0.5s ease-out;
//   min-height: 600px;
// }
svg.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
#app,
body,
html {
  height: 100%;
  font-size: 14px;
  min-width: 1280px;
  font-family: "微软雅黑";
  overflow: auto;
}
.iconfont {
  font-size: 16px;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  color: #ffffff;
}
/** **************************** el全局按钮样式 ********************** */
.el-button--danger {
  .is-plain {
    background: #ffffff;
  }
}
.avue-crud__menu {
  margin-top: 8px;
}
.avue-crud__search .el-form-item .el-form-item {
  margin-bottom: 0;
}
// TopBar
$topNormalTextColor: rgba(255, 255, 255, 0.1);
$topNormalTextColorHover: rgba(0, 0, 0, 0.4);

// logo
.jt {
  position: absolute;
  left: 40px;
  top: 40px;
  i {
    color: #e60012;
    font-size: 32px;
  }
}
.pull-left {
  float: left;
}
</style>
